// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d2069f0e","977":"652be7dc"}[chunkId] + ".chunk.js";
};